import { useMemo } from 'react'

import {
  fwCoreNoncoreSssBreakdownConfig,
  fwMarketSssBreakdownConfig,
  useFwCoreNoncoreSssBreakdown as useCoreNoncoreSssBreakdown,
  useFwMarketSssBreakdown as useMarketSssBreakdown,
} from '../../chart/hooks/farwest/useSssBreakdown'
import { useVariables } from '../../variables'

export { fwCoreNoncoreSssBreakdownConfig, fwMarketSssBreakdownConfig }

export const useFwCoreNoncoreSssBreakdown = () => {
  const { variables } = useVariables()
  const { data, loading } = useCoreNoncoreSssBreakdown()
  const metrics = (() => {
    switch (variables.selectOptions?.orderMode?.value[0][0]) {
      case 'net_sales':
        return 'SSS%'

      case 'check_count':
        return 'SST%'

      case 'check_average':
        return 'SSC%'

      default:
        return null
    }
  })()

  return {
    data: useMemo(() => {
      return {
        source: data?.map((d) => ({
          ...d,
          period: `${d.period} - ${metrics}`,
        })),
        summary: null,
      }
    }, [data]),
    loading,
  }
}

export const useFwMarketSssBreakdown = () => {
  const { variables } = useVariables()
  const { data, loading } = useMarketSssBreakdown()
  const metrics = (() => {
    switch (variables.selectOptions?.orderMode?.value[0][0]) {
      case 'net_sales':
        return 'SSS%'

      case 'check_count':
        return 'SST%'

      case 'check_average':
        return 'SSC%'

      default:
        return null
    }
  })()

  return {
    data: useMemo(() => {
      return {
        source: data?.map((d) => ({
          ...d,
          period: `${d.period} - ${metrics}`,
        })),
        summary: null,
      }
    }, [data]),
    loading,
  }
}
